import { defineComponent as _defineComponent } from 'vue'
import BaseStatus from "@/components-UI/BaseStatus.vue";
import { StatusCellData } from "@/utils/CellsFactory";
import { computed } from "vue";

interface Props {
    value: string | object | boolean;
    data: StatusCellData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusCell',
  props: {
    value: { type: [String, Object, Boolean] },
    data: null
  },
  setup(__props: any) {

const props = __props as {
    value: string | object | boolean;
    data: StatusCellData;
}




const getStatus = computed(() => {
    if (props.data.translate && (typeof props.value === 'string' || typeof props.value === 'boolean')) {
        return props.data.translate(props.value);
    }
    return props.value;
});

return { __sfc: true,props, getStatus, BaseStatus }
}

})